const meta = (title) => ({ showNavbar: true, title, icon: 'mobile', label: title, roles: ['Admin'] })

/*
 * Rotas aninhadas: o AppShell (Layout + router-view) monta uma única vez e
 * persiste enquanto o usuário navega entre as telas do módulo — a sidebar
 * não re-renderiza a cada troca de tela. As páginas filhas NÃO embrulham
 * <Layout>; renderizam apenas o conteúdo.
 */
export default [
  {
    path: '/app',
    component: () => import(/* webpackChunkName: "app-module" */ './AppShell.vue'),
    redirect: '/app/dashboard',
    children: [
      {
        name: 'app-dashboard',
        path: 'dashboard',
        component: () => import(/* webpackChunkName: "app-module" */ './Dashboard.vue'),
        meta: meta('Dashboard do App')
      },
      {
        name: 'app-config',
        path: 'config',
        component: () => import(/* webpackChunkName: "app-module" */ './Config.vue'),
        meta: meta('App')
      },
      {
        name: 'app-customization',
        path: 'customization',
        component: () => import(/* webpackChunkName: "app-module" */ './Customization.vue'),
        meta: meta('Customização do App')
      },
      {
        name: 'app-menu',
        path: 'menu',
        component: () => import(/* webpackChunkName: "app-module" */ './Menu.vue'),
        meta: meta('Menu do App')
      },
      {
        name: 'app-feed',
        path: 'feed',
        component: () => import(/* webpackChunkName: "app-module" */ './Feed.vue'),
        meta: meta('Feed do App')
      },
      {
        name: 'app-terms',
        path: 'terms',
        component: () => import(/* webpackChunkName: "app-module" */ './Terms.vue'),
        meta: meta('Termos do App')
      },
      {
        name: 'app-notifications',
        path: 'notifications',
        component: () => import(/* webpackChunkName: "app-module" */ './Notifications.vue'),
        meta: meta('Notificações do App')
      },
      {
        name: 'app-agenda',
        path: 'agenda',
        component: () => import(/* webpackChunkName: "app-module" */ './Agenda.vue'),
        meta: meta('Agenda do App')
      },
      {
        name: 'app-speakers',
        path: 'speakers',
        component: () => import(/* webpackChunkName: "app-module" */ './Speakers.vue'),
        meta: meta('Palestrantes do App')
      },
      {
        name: 'app-videos',
        path: 'videos',
        component: () => import(/* webpackChunkName: "app-module" */ './Videos.vue'),
        meta: meta('Vídeos do App')
      },
      {
        name: 'app-archives',
        path: 'archives',
        component: () => import(/* webpackChunkName: "app-module" */ './Archives.vue'),
        meta: meta('Arquivos do App')
      },
      {
        name: 'app-faq',
        path: 'faq',
        component: () => import(/* webpackChunkName: "app-module" */ './Faq.vue'),
        meta: meta('FAQ do App')
      },
      {
        name: 'app-guide',
        path: 'guide',
        component: () => import(/* webpackChunkName: "app-module" */ './Guide.vue'),
        meta: meta('Guia do App')
      },
      {
        name: 'app-partners',
        path: 'partners',
        component: () => import(/* webpackChunkName: "app-module" */ './Partners.vue'),
        meta: meta('Patrocinadores do App')
      },
      {
        name: 'app-partner-edit',
        path: 'partners/:id',
        component: () => import(/* webpackChunkName: "app-module" */ './PartnerEdit.vue'),
        meta: meta('Patrocinador do App')
      },
      {
        name: 'app-feed-moderation',
        path: 'feed-moderation',
        component: () => import(/* webpackChunkName: "app-module" */ './FeedModeration.vue'),
        meta: meta('Moderação do Feed')
      },
      {
        name: 'app-interests',
        path: 'interests',
        component: () => import(/* webpackChunkName: "app-module" */ './Interests.vue'),
        meta: meta('Networking do App')
      },
      {
        name: 'app-rooms',
        path: 'rooms',
        component: () => import(/* webpackChunkName: "app-module" */ './Rooms.vue'),
        meta: meta('Salas & Interações')
      },
      {
        name: 'app-room-edit',
        path: 'rooms/:id',
        component: () => import(/* webpackChunkName: "app-module" */ './RoomEdit.vue'),
        meta: meta('Sala ao vivo')
      },
      {
        name: 'app-gamification',
        path: 'gamification',
        component: () => import(/* webpackChunkName: "app-module" */ './Gamification.vue'),
        meta: meta('Gamificação')
      },
      {
        name: 'app-store',
        path: 'store',
        component: () => import(/* webpackChunkName: "app-module" */ './PointsStore.vue'),
        meta: meta('Loja de Pontos')
      },
      {
        name: 'app-raffles',
        path: 'raffles',
        component: () => import(/* webpackChunkName: "app-module" */ './Raffles.vue'),
        meta: meta('Sorteios')
      },
      {
        name: 'app-rewards',
        path: 'rewards',
        component: () => import(/* webpackChunkName: "app-module" */ './Rewards.vue'),
        meta: meta('Recompensas')
      },
      {
        name: 'app-certificates',
        path: 'certificates',
        component: () => import(/* webpackChunkName: "app-module" */ './Certificates.vue'),
        meta: meta('Certificados')
      },
      {
        name: 'app-survey',
        path: 'survey',
        component: () => import(/* webpackChunkName: "app-module" */ './Survey.vue'),
        meta: meta('Pesquisa')
      },
      {
        name: 'app-emails',
        path: 'emails',
        component: () => import(/* webpackChunkName: "app-module" */ './EmailTemplates.vue'),
        meta: meta('E-mails do App')
      },
      {
        name: 'app-reports',
        path: 'reports',
        component: () => import(/* webpackChunkName: "app-module" */ './Reports.vue'),
        meta: meta('Relatórios do App')
      }
    ]
  }
]
